import Axios from 'axios';
const axios = Axios.create({ withCredentials: true });

(function () {
  // perform signin
  var signout = function () {
    const apiUri = process.env.AUTH_API_BASE + '/auth/signout';
    axios
      .get(apiUri)
      .then(() => {})
      .catch(() => {})
      .finally(() => {
        window.location.href = '/';
      });
  };

  setTimeout(signout, 1000);
})();
